import styled from "styled-components";
import { BRAND, TEXT_SECONDARY } from "@streeteasy/design-system/colors";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import { Caption, SecondarySmall } from "@streeteasy/design-system/typography";

import { largeScreen } from "src/shared/constants/screenSizes";

export const Container = styled.div`
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex: 1 1 0;
  margin: 0 12px;
  max-width: 420px;
  min-width: 0;
  position: relative;

  @media screen and (max-width: ${largeScreen}px) {
    margin: 0 0 23px;
    max-width: 100%;
  }
`;

export const RecentSearchContent = styled.div`
  max-height: 88px;
  overflow: hidden;
  padding: 27px 16px 10px;
`;

export const Title = styled(SecondarySmall).attrs({
  as: "h3"
})`
  color: ${BRAND};
  height: 24px;
  margin: 0 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Description = styled(Caption)`
  color: ${TEXT_SECONDARY};
`;

export const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  position: absolute;
  right: 8px;
  top: 8px;
`;

export const SaveIcon = styled(FontAwesomeIcon)`
  color: ${BRAND};
  font-size: 20px;
  padding: 0;
`;

export const Link = styled.a`
  bottom: 0;
  display: block;
  font-size: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;
